
import { Button } from "antd";
import { API } from "../Axios/Axios";

const SampleWorkflow = () => {
  
    const GetAllActiveWorkflows = async () => {
          
          try {
            const response = await API.post("/Workflow/GetAllActiveWorkflows", {});

            console.log(response);
          } catch (error) {
            console.error("Failed:", error);
          }
        };

        const GetWorkflowByName = async () => {
          const formData = {
            WorkflowSystemName: 'AssetAllocation'
          }
    
          try {
            const response = await API.post("/Workflow/GetWorkflowByName", formData);

            console.log(response);
          } catch (error) {
            console.error("Failed:", error);
          }
        };

        const CreateWorkflow = async () => {
            const formData = {
              WorkflowName: 'abc',
              WorkflowSystemName: 'abcApproval',
              Description: 'desc',
              CreatedBy: 6,
              Id: 0
            };
      
            try {
              const response = await API.post("/Workflow/CreateWorkflow", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const UpdateWorkflow = async () => {
            const formData = {
              WorkflowId: 11,
              WorkflowName: 'abcc',
              Description: 'abc desc update test',
              IsActive: false,
              CreatedBy: 6
            };
      
            try {
              const response = await API.post("/Workflow/UpdateWorkflow", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const StartWorkflow = async () => {
            const formData = {  
              WorkflowId: 11,
              TransactionId: 3,
              CreatedBy: 6
            }
      
            try {
              const response = await API.post("/Workflow/StartWorkflow", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const GetWorkflowInstance = async () => {
            const formData = {
              WorkflowInstanceId: 251
            }
      
            try {
              const response = await API.post("/Workflow/GetWorkflowInstance", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const GetWorkflowHistory = async () => {
            const formData = {
              WorkflowInstanceId: 254
            }
      
            try {
              const response = await API.post("/Workflow/GetWorkflowHistory", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const MoveToNextWorkflow = async () => {
            const formData = {
              WorkflowInstanceId: 41,
              Action: 'APPROVE',
              CreatedBy: 6,
              TerminateCurrentTask: true
            }
      
            try {
              const response = await API.post("/Workflow/MoveToNextStage", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const SkipStage = async () => {
            const formData = {
              WorkflowInstanceId: 20,
              userId: 9,
              CreatedBy: 6
            }
      
            try {
              const response = await API.post("/Workflow/SkipStage", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
            
          };

          const GetUserTasks = async () => {
            const formData = {UserId: 14}
      
            try {
              const response = await API.post("/Tasks/GetUserTasks", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const GetAllTasks = async () => {
            const formData = {
              // WorkflowInstanceId: 20,
              // StageSystemName: 'MGR_APPROVAL',
              // CreatedBy: 6
            }
      
            try {
              const response = await API.post("/Tasks/GetAllTasks", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const GetTaskDetails = async () => {
            const formData = {
              TaskId: 38611
            }
      
            try {
              const response = await API.post("/Tasks/GetTaskDetails", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const CreateTask = async () => {
            const formData = {
              WorkflowInstanceId: 251,
              stageId: 37,
              Remarks: 'task test remark',
              CreatedBy: 6
            }
      
            try {
              const response = await API.post("/Tasks/CreateTask", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const JumpToStage = async () => {
            const formData = {
              WorkflowInstanceId: 20,
              StageSystemName: 'MGR_APPROVAL',
              CreatedBy: 6
            }
      
            try {
              const response = await API.post("/Workflow/JumpToStage", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

          const UpdateTask = async () => {
            const formData = {
              TaskId: 35807,
              TaskOutcome: 'Approved',
              DueDate: null,
              CreatedBy: 6,
              Remarks: 'test rem'
            }
      
            try {
              const response = await API.post("/Tasks/UpdateTask", formData);
  
              console.log(response);
            } catch (error) {
              console.error("Failed:", error);
            }
          };

    return (
      
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="pageName">
                <h4>Workflow</h4>
              </div>

              <Button
                type="primary"
                onClick={() => {GetAllActiveWorkflows()}}
              >
                Get All Active Workflows
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {GetWorkflowByName()}}
              >
                Get Workflow By Name
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {CreateWorkflow()}}
              >
                Create Workflow
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {UpdateWorkflow()}}
              >
                Update Workflow
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {StartWorkflow()}}
              >
                Start Workflow
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {GetWorkflowInstance()}}
              >
                Get WorkflowInstance
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {GetWorkflowHistory()}}
              >
                Get Workflow History
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {MoveToNextWorkflow()}}
              >
                Move To Next Workflow
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {SkipStage()}}
              >
                Skip Stage
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {JumpToStage()}}
              >
                Jump To Stage
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {GetUserTasks()}}
              >
                Get User Tasks
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {GetAllTasks()}}
              >
                Get All Tasks
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {GetTaskDetails()}}
              >
                Get Task Details
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {CreateTask()}}
              >
                Create Task
              </Button>
              <Button
              style={{ marginLeft: "3px" }}
                type="primary"
                onClick={() => {UpdateTask()}}
              >
                Update Task
              </Button>

            </div>
          </div>
        </div>
    );
  };
  
  export default SampleWorkflow;
  